import dynamic from 'next/dynamic';
import React from 'react';

import { Modal } from '~components/Modals/Base';

import type { ForgotPasswordModalProps } from '../../model/types';

const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

export const ForgotPasswordModal = ({
	locked,
	onClose,
	open,
	onBack,
}: ForgotPasswordModalProps) => {
	return (
		<Modal open={open} locked={locked} onClose={onClose}>
			<Content open={open} locked={locked} onClose={onClose} onBack={onBack} />
		</Modal>
	);
};
